'use client'

import {Heart} from 'lucide-react'
import {observer} from 'mobx-react'
import React from 'react'

import theme from '@/src/config/theme'
import {Product} from '@/src/core/domain/entities/product'
import {useFavourite} from '@/src/features/favourite'

import * as UI from './favourite-btn.styled'

export const FavouriteBtn = observer(
  ({productId, className}: {productId: Product['id']; className?: string; isFavourite?: boolean}) => {
    const favouriteVm = useFavourite()

    const isFavourite = favouriteVm.is(productId)

    const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation()
      favouriteVm.toggle(productId)
    }

    return (
      <UI.AddFavouriteBtn
        className={className}
        onClick={onClick}
        $visible={isFavourite}
        aria-label={isFavourite ? 'Убрать из избранного' : 'Добавить в избранное'}>
        <Heart
          strokeWidth={1}
          fill={isFavourite ? theme.colors.primary : theme.colors.white}
          stroke={theme.colors.primary}
        />
      </UI.AddFavouriteBtn>
    )
  },
)
